module.exports = __webpack_public_path__ + "media/bundles/bundles-left-6f6433ec.svg";